import { useEffect, useState } from 'react'

export const useDebouncedSearch = (
  delay = 700,
): {
  searchType: string
  setSearchType: (value: string) => void
  searchTerm: string
  setSearchTerm: (value: string) => void
  debouncedTerm: string
} => {
  const [searchType, setSearchType] = useState('project')
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedTerm, setDebouncedTerm] = useState('')

  useEffect(() => {
    const id = setTimeout(() => setDebouncedTerm(searchTerm), delay)
    return () => clearTimeout(id)
  }, [searchTerm, delay])

  return { searchType, setSearchType, searchTerm, setSearchTerm, debouncedTerm }
}
